import React from "react";
import { useTranslation } from "react-i18next";
import { GiftCategory } from "../../../types/modules/admin/giftCategory.type";
import GiftCategoryItem from "./GiftCategoryItem";
import { PermissionGate } from "../PermissionGate";
import { PermissionsKey } from "../../../data/permissions";

interface Props {
  gifts: GiftCategory[];
}

const GiftCategoryListTable: React.FC<Props> = ({ gifts }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal capitalize">{t("id")}</th>
            <th className="p-3 font-normal capitalize">{t("name_in_english")}</th>
            <th className="p-3 font-normal capitalize">{t("name_in_arabic")}</th>
            <th className="p-3 font-normal capitalize">{t("templates")}</th>
            <PermissionGate permissions={[PermissionsKey.UpdateGiftCategory]}>
              <th className="p-3 font-normal capitalize">{t("actions")}</th>
            </PermissionGate>
          </tr>
        </thead>
        <tbody className="text-sm">
          {gifts.map((gift, index) => (
            <tr
              key={gift.id}
              className="bg-white rounded-[12px]"
              style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
            >
                <GiftCategoryItem gift={gift}/>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default GiftCategoryListTable;